import {
  Navigate,
  createBrowserRouter,
  useLocation,
} from "react-router-dom";
import Login from "pages/login";
import Signup from "pages/signup";
import MainLayout from "layouts/MainLayout";
import Dashboard from "pages/Dashboard";
import ContentManager from "pages/ContentManager";
import ContentLayout from "pages/Content/layout";
import Transcript from "pages/Content/transcript";
import Content from "pages/Content/content";
import Settings from "pages/Settings/Settings";
import { auth } from "services/firebase";
import { useAuthState } from "react-firebase-hooks/auth";
import VoiceConversionTab from "components/shared/Tabs/VoiceConversionTab";
import ProfileTab from "components/shared/Tabs/ProfileTab";
import PaymentSettingsTab from "components/shared/Tabs/PaymentSettingsTab";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  let location = useLocation();
  const [user, loading, error] = useAuthState(auth);

  if (error) {
    return (
      <div>
        <p>Error: {JSON.stringify(error)}</p>
      </div>
    );
  }
  if (user || loading) {
    return <>{children}</>;
  }

  return <Navigate to="/login" state={{ from: location }} replace />;
};

export const router = createBrowserRouter([
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/signup",
    element: <Signup />,
  },
  {
    element: (
      <ProtectedRoute>
        <MainLayout />
      </ProtectedRoute>
    ),
    children: [
      {
        path: "/",
        element: <Dashboard />,
      },
      {
        path: "/content",
        element: <ContentManager />,
      },
      {
        element: <ContentLayout />,
        children: [
          {
            path: "/content/:id/:language",
            element: <Content />,
          },
          {
            path: "/content/:id/:language/transcript",
            element: <Transcript />,
          },
        ],
      },
      {
        path: "/settings",
        element: <Navigate to="/settings/profile" replace />,
      },
      {
        path: "/settings",
        element: <Settings />,
        children: [
          {
            path: "/settings/profile",
            element: <ProfileTab />,
          },
          {
            path: "/settings/voice-conversion",
            element: <VoiceConversionTab/>,
          },
          {
            path: "/settings/payment-settings",
            element: <PaymentSettingsTab/>,
          },
        ],
      },
    ],
  },
]);
